export function initIncomePercentPie ({ vue, res }) {
  let options = {
    color: ['#1d5eeb', '#65d5d1', '#edcd4b', '#e26032', '#312d6f', '#866dbc'],
    tooltip: {
      trigger: 'item'
    },
    legend: {
      show: true,
      textStyle: {
        color: 'white'
      },
      icon: 'circle',
      right: 10,
      orient: 'vertical',
      top: '20%'
    },
    series: [
      {
        name: 'Access From',
        type: 'pie',
        radius: '70%',
        data: [],
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: 'rgba(0, 0, 0, 0.5)'
          }
        },
        label: {
          alignTo: 'edge',
          formatter: '{c} %',
          minMargin: 5,
          edgeDistance: '25%',
          lineHeight: 15
        }
      }
    ]
  }
  options.series[0].data = res.map((item, index) => {
    let { appName, percent } = item
    return {
      name: appName,
      value: percent,
      label: {
        color: options.color[index]
      }
    }
  })
  return options
}

export function lineFormatDataSecond ({ data, yKey, type, vue, yAxisMin = 0 }) {
  const isAndroid = vue.$store.state.app.isAndroid
  const keys = Object.keys(data)
  let minValueArr = []
  keys.forEach((item) => {
    minValueArr.push(vue.mathMin(data[item].data))
  })
  const minValue = vue.mathMin(minValueArr)
  let xData = []
  if (data[keys[0]] && data[keys[0]].data) {
    xData = data[keys[0]].date.map(item => {
      return vue.$cUtils.format.formatDate(item, 'MM-dd')
    })
  }
  const option = {
    config: {
      color: false,
      title: {
        // text: 'Referer of a Website',
        textStyle: {
          color: '#fff',
          fontSize: 20
        }
      },
      xData: xData,
      splitNumber: 2,
      legend: {
        top: !isAndroid ? 20 : 10,
        right: 10
      },
      grid: {
        top: 60,
        right: 10,
        bottom: 10
      },
      yAxis: [],
      xAxis: []
    },
    data: []
  }
  const yAxis = {
    name: yKey[0],
    type: 'value',
    splitLine: {
      lineStyle: {
        color: 'rgba(255,255,255,0.1)'
      }
    },
    min: yAxisMin,
    axisLine: {
      show: false
    },
    axisLabel: {
      show: true,
      textStyle: {
        color: 'rgba(255,255,255,.6)',
        fontSize: !isAndroid ? 12 : 10
      }
    },
    nameTextStyle: {
      color: '#999',
      fontSize: !isAndroid ? 12 : 10
    },
    splitNumber: 4
  }
  option.config.yAxis.push(yAxis)
  if (yKey.length > 1 && !!yKey[1]) {
    const copyYAxis = JSON.parse(JSON.stringify(yAxis))
    vue.$set(copyYAxis, 'name', yKey[1])
    option.config.yAxis.push(copyYAxis)
  }
  keys.forEach(item => {
    const itemData = {
      name: item,
      data: data[item].data,
      symbol: 'none',
      lineStyle: {
        type: item === '目标' ? 'dashed' : 'solid',
        width: !isAndroid ? 2 : 0.5
      },
      type: 'line',
      smooth: true,
      yAxisIndex: item === '活跃率' ? 1 : 0
    }
    if (type && item !== '目标') {
      vue.$set(itemData, 'areaStyle', {})
      vue.$set(itemData, 'stack', '总量')
    }
    option.data.push(itemData)
  })
  // this.ChartBarLineData = option
  return option
}
